/**
 * @desc 导出订单
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(params: API.omsFlow.systemOrder.exporting.DiffDto, options?: any) {
  return updateResponse(
    http(URL + `/systemOrder/export`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
